import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Cookie } from "lucide-react";

const CookiesPage = () => (
    <div className="max-w-3xl mx-auto space-y-6 text-elegant text-sm leading-relaxed" data-testid="cookies-page">
        <Link to="/dashboard" className="inline-flex items-center gap-2 text-brand hover:underline text-sm">
            <ArrowLeft className="w-4 h-4" /> Torna alla dashboard
        </Link>
        <div>
            <div className="text-xs uppercase tracking-[0.3em] text-brand mb-2">Informativa</div>
            <h1 className="font-display text-4xl font-bold text-warm flex items-center gap-3">
                <Cookie className="w-9 h-9 text-brand" /> Cookie Policy
            </h1>
            <div className="text-xs text-elegant mt-2">Ultimo aggiornamento: 8 maggio 2026</div>
        </div>

        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">Cosa sono i cookie</h2>
            <p>I cookie sono piccoli file di testo memorizzati sul tuo dispositivo dal browser. Smart Table utilizza esclusivamente cookie tecnici necessari al funzionamento del gestionale.</p>
        </section>

        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">Cookie utilizzati</h2>
            <table className="w-full text-xs border border-[#1f2c44] rounded overflow-hidden">
                <thead className="bg-deep">
                    <tr><th className="text-left p-2">Nome</th><th className="text-left p-2">Tipo</th><th className="text-left p-2">Durata</th><th className="text-left p-2">Scopo</th></tr>
                </thead>
                <tbody className="text-elegant">
                    <tr className="border-t border-[#1f2c44]"><td className="p-2 font-mono">access_token</td><td className="p-2">Tecnico essenziale</td><td className="p-2">7 giorni</td><td className="p-2">Autenticazione utente</td></tr>
                    <tr className="border-t border-[#1f2c44]"><td className="p-2 font-mono">customer_token</td><td className="p-2">Tecnico essenziale</td><td className="p-2">Sessione</td><td className="p-2">Autenticazione clienti portale</td></tr>
                    <tr className="border-t border-[#1f2c44]"><td className="p-2 font-mono">cookie_consent_v1</td><td className="p-2">Tecnico essenziale</td><td className="p-2">12 mesi</td><td className="p-2">Memorizzazione consenso cookie</td></tr>
                </tbody>
            </table>
        </section>

        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">Cookie di terze parti</h2>
            <p>
                <strong className="text-warm">Stripe</strong>: solo durante il checkout abbonamento, per prevenzione frodi e gestione pagamento. Vedi <a href="https://stripe.com/cookies-policy/legal" target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">privacy Stripe</a>.<br />
                <strong className="text-warm">Google</strong>: solo se usi "Accedi con Google" come admin. Vedi <a href="https://policies.google.com/technologies/cookies" target="_blank" rel="noopener noreferrer" className="text-brand hover:underline">policy Google</a>.
            </p>
        </section>

        <section className="space-y-3">
            <h2 className="font-display text-xl font-bold text-warm">Gestione consenso</h2>
            <p>Puoi modificare la tua scelta in qualsiasi momento cancellando i dati del browser, oppure svuotando lo storage di questo sito. Al prossimo accesso ti verrà richiesto nuovamente il consenso.</p>
            <button onClick={() => { localStorage.removeItem("cookie_consent_v1"); window.location.reload(); }}
                data-testid="reset-cookie-consent"
                className="h-10 px-4 border border-brand text-brand rounded-md text-xs uppercase tracking-wider hover:bg-brand-soft">
                Resetta scelta cookie
            </button>
        </section>
    </div>
);

export default CookiesPage;
